import { useEffect, useState } from 'react';
import { useSelector, useStore } from 'react-redux';

// utils
import getEndpoint from 'utils/endpoints';
import { globalsSearchSegmentSelector } from 'utils/selectors/globalsSelectors';
import { fetchWithInterceptors } from 'utils/interceptors';

export function useSuggestions(value) {
  const [suggestions, setSuggestions] = useState([]);
  const state = useStore();
  const segment = useSelector(globalsSearchSegmentSelector);
  const endpoint = `${getEndpoint('suggest', state)}`;

  useEffect(() => {
    if (!value) {
      setSuggestions([]);
    }

    const params = new URLSearchParams({
      segment: segment ?? '',
      q: value,
    });
    fetchWithInterceptors(`${endpoint}?${params.toString()}`)
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`api error: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        setSuggestions(data.suggestions);
      })
      .catch(() => {
        setSuggestions([]);
      });
  }, [endpoint, segment, value]);

  return suggestions;
}
